module.exports = "<div [hidden]=\"!chart\" style=\"position: relative\" [ngStyle]=\"{'width': widthOfChart > 0 ? (widthOfChart + 'vw') : 'auto'}\">\r\n  <canvas id=\"canvas{{type}}\" height=\"300px\" #canvas>{{ chart }}</canvas>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/diagram/diagram.component.html
// module id = ./src/app/shared/components/diagram/diagram.component.html
// module chunks = main